<template>
  <div class="class-details-modal">
    <div class="view-class-detail">
      <a
        data-w-id="9f5380cc-bfa0-7e75-f25a-5fff76ecd0b7"
        href="#"
        class="link-block-5 w-inline-block"
        @click="cancel"
      >
        <img
          src="@/assets/timeslot-images/cancelIconNew.svg"
          loading="lazy"
          alt=""
      /></a>
      <div class="div-block-197">
        <img
          :src="
            singleGroupSession.professionalDisplayPicture ||
              require('@/assets/timeslot-images/profileImg.svg')
          "
          loading="lazy"
          width="136"
          alt=""
          class="prof-image"
        />
      </div>
      <p class="class-title">
        {{ singleGroupSession.groupSessionTopic
        }}<a href="#" class="link-10"></a>
      </p>
      <div class="div-block-80" style="flex-direction: row; margin-top: 0;">
        <div class="div-block-82" style="margin-bottom: 5px;">
          <div class="div-block-81">
            <img
              src="@/assets/timeslot-images/calendar1.svg"
              loading="lazy"
              alt=""
              class="image-17"
            />
            <div class="text-block-67">
              {{
                new Date(singleGroupSession.groupSessionStartTime.slice(0, 10))
                  .toString()
                  .slice(0, 11)
              }}
            </div>
          </div>
          <div class="div-block-81">
            <img
              src="@/assets/timeslot-images/money.svg"
              loading="lazy"
              alt=""
              class="image-17"
            />
            <div class="text-block-67">
              ${{ singleGroupSession.groupSessionAmount }}
            </div>
          </div>
        </div>
        <div class="div-block-82" style="margin-bottom:5px;">
          <div class="div-block-81">
            <img
              src="@/assets/timeslot-images/calendar1.svg"
              loading="lazy"
              alt=""
              class="image-17"
            />
            <div class="text-block-67">
              {{
                formatHours(new Date(singleGroupSession.groupSessionStartTime))
              }}:{{
                formatMinutes(
                  new Date(singleGroupSession.groupSessionStartTime)
                )
              }}
              {{
                formatTime(new Date(singleGroupSession.groupSessionStartTime))
              }}
              -
              {{
                formatHours(new Date(singleGroupSession.groupSessionEndTime))
              }}:{{
                formatMinutes(new Date(singleGroupSession.groupSessionEndTime))
              }}
              {{ formatTime(new Date(singleGroupSession.groupSessionEndTime)) }}

              <!--              {{ singleGroupSession.groupSessionMaxAttendance }} students-->
            </div>
          </div>
        </div>
      </div>
      <div class="div-block-83" style="margin-top:10px;">
        <div>
          <div class="text-block-68" style="margin-bottom:5px;">
            Description
          </div>
          <div style="margin-bottom:10px;">
            <strong class="bold-text">{{
              singleGroupSession.groupSessionDescription
            }}</strong
            ><br />
          </div>
        </div>
      </div>
      <BaseComponentLoader
        v-if="loader.nonBlockingLoader"
        loaderAlignment="right"
      />
      <div
        data-w-id="9f5380cc-bfa0-7e75-f25a-5fff76ecd0d8"
        v-else
        class="button-15 w-button"
        @click="enroll"
      >
        Book a spot
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import GroupSessionRequest from "@/model/requests/GroupSessionRequest";
import StoreUtils from "@/utils/BaseUtils/StoreUtils";
import BaseComponentLoader from "@/components/BaseComponents/BaseComponentLoader";
import moment from "moment";

export default {
  name: "ClassDetailsModal",
  components: { BaseComponentLoader },
  data() {
    return {
      detailsModel: GroupSessionRequest.enroll
    };
  },
  computed: {
    ...mapState({
      singleProfessional: state => state.professional.singleProfessional,
      singleGroupSession: state => state.groupSession.singleGroupSession,
      userInfo: state => state.auth.userInfo
    }),
    ...mapState(["loader"])
  },
  props: {
    profName: String,
    cancel: Function,
    buttonAction: Function
  },
  methods: {
    enroll() {
      this.detailsModel.customerId = this.userInfo.customerId;
      this.detailsModel.groupSessionId = this.singleGroupSession.groupSessionId;
      StoreUtils.dispatch("groupSession/enroll", this.detailsModel).then(() => {
        this.cancel();
        StoreUtils.dispatch("groupSession/readEnrolledClassCustomers", {
          groupSessionId: this.groupSession.groupSessionId
        });
        StoreUtils.dispatch("groupSession/readUserGroupSessions");
      });
    },
    formatTime(date) {
      return moment(date).format("a");
    },
    formatMinutes(date) {
      return moment(date).format("mm");
    },
    formatHours(date) {
      return moment(date).format("h");
    }
  }
};
</script>

<style scoped>
.prof-image {
  width: 100px;
  height: 100px;
  border-radius: 50%;
}
</style>
